import React, { Component } from 'react';
import { ToastContainer,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { css } from 'react-emotion';
// First way to import
import { ClipLoader } from 'react-spinners';
import APIService from '../Services/APIService/apiService';
import { Button, Badge } from 'reactstrap';
import {  Redirect } from 'react-router-dom';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class Xero extends Component{

    constructor(props){
        super(props);
        this.state = {
            APIName: "xero",
            SubGroups: "",
            EasyApiUser: "",
            EasyApiPassword: "",
            ApiAccess: "",
            CallbackUrl: "",
            ConsumerKey: "",
            ConsumerSecret: "",
            SigningCertificate: "",
            SigningCertificatePassword: "",
            DayWeekNumber: "",
            Hour: "",
            EmailsAlertTo: "",
            EmailSubjectError: "",
            loadingXero: false,
            type: 'password',
            isAutenticated: true
        };

        this.handleEasyApiUser = this.handleEasyApiUser.bind(this);
        this.handleSubGroups = this.handleSubGroups.bind(this);
        this.handleEasyApiPassword = this.handleEasyApiPassword.bind(this);
        this.handleApiAccess= this.handleApiAccess.bind(this);
        this.handleCallbackUrl = this.handleCallbackUrl.bind(this);
        this.handleConsumerKey = this.handleConsumerKey.bind(this);
        this.handleConsumerSecret = this.handleConsumerSecret.bind(this);
        this.handleSigningCertificate = this.handleSigningCertificate.bind(this);
        this.handleSigningCertificatePassword = this.handleSigningCertificatePassword.bind(this);
        this.handleDayWeekNumber = this.handleDayWeekNumber.bind(this);
        this.handleHour = this.handleHour.bind(this);
        this.handleEmailsAlertTo = this.handleEmailsAlertTo.bind(this);
        this.handleEmailSubjectError = this.handleEmailSubjectError.bind(this);
        this.showHide = this.showHide.bind(this);
    }  

    showHide(e){
        e.preventDefault();
        e.stopPropagation();
        this.setState({
          type: this.state.type === 'input' ? 'password' : 'input'
        })  
    }
    componentDidMount(){
      
        var XeroList = this.props.DataXero;

        var Xero = XeroList.find(x=> x.ALIAS === this.state.APIName); 
        var XeroValue = JSON.parse(Xero.VALUE);
        var SubGroups = XeroValue.SubGroups === null || XeroValue.SubGroups === undefined   ? "" :  XeroValue.SubGroups;
        var EasyApiUser = XeroValue.EasyApiUser === null || XeroValue.EasyApiUser === undefined   ? "" :  XeroValue.EasyApiUser;
        var EasyApiPassword = XeroValue.EasyApiPassword === null || XeroValue.EasyApiPassword === undefined   ? "" :  XeroValue.EasyApiPassword;
        var ApiAccess = XeroValue.ApiAddress === null || XeroValue.ApiAddress === undefined   ? "" :  XeroValue.ApiAddress;
        var CallbackUrl = XeroValue.CallbackUrl === null || XeroValue.CallbackUrl === undefined   ? "" :  XeroValue.CallbackUrl;
        var ConsumerKey = XeroValue.ConsumerKey === null || XeroValue.ConsumerKey === undefined   ? "" :  XeroValue.ConsumerKey;
        var ConsumerSecret = XeroValue.ConsumerSecret === null || XeroValue.ConsumerSecret === undefined   ? "" :  XeroValue.ConsumerSecret;
        var SigningCertificate = XeroValue.SigningCertificate === null || XeroValue.SigningCertificate === undefined   ? "" :  XeroValue.SigningCertificate;
        var SigningCertificatePassword = XeroValue.SigningCertificatePassword === null || XeroValue.SigningCertificatePassword === undefined   ? "" :  XeroValue.SigningCertificatePassword;
        var DayWeekNumber = XeroValue.DayWeekNumber === null || XeroValue.DayWeekNumber === undefined   ? "" :  XeroValue.DayWeekNumber;
        var Hour = XeroValue.Hour === null || XeroValue.Hour === undefined   ? "" :  XeroValue.Hour;
        var EmailsAlertTo = XeroValue.EmailsAlertTo === null || XeroValue.EmailsAlertTo === undefined   ? "" :  XeroValue.EmailsAlertTo;
        var EmailSubjectError = XeroValue.EmailSubjectError === null || XeroValue.EmailSubjectError === undefined   ? "" :  XeroValue.EmailSubjectError;

        let stateCopy = Object.assign({}, this.state);
        stateCopy.SubGroups = SubGroups;
        stateCopy.EasyApiUser = EasyApiUser;
        stateCopy.EasyApiPassword = EasyApiPassword;
        stateCopy.ApiAccess = ApiAccess;
        stateCopy.CallbackUrl = CallbackUrl;
        stateCopy.ConsumerKey = ConsumerKey;
        stateCopy.ConsumerSecret = ConsumerSecret;
        stateCopy.SigningCertificate = SigningCertificate;
        stateCopy.SigningCertificatePassword = SigningCertificatePassword;
        stateCopy.DayWeekNumber = DayWeekNumber;
        stateCopy.Hour = Hour;
        stateCopy.EmailsAlertTo = EmailsAlertTo;
        stateCopy.EmailSubjectError = EmailSubjectError;
        this.setState(stateCopy);
    }
    handleSubGroups(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.SubGroups = value;
        this.setState(stateCopy);    
    }
    handleEasyApiUser(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.EasyApiUser = value;
        this.setState(stateCopy);    
    }
    handleEasyApiPassword(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.EasyApiPassword = value;
        this.setState(stateCopy);    
    }
    handleApiAccess(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.ApiAccess = value;
        this.setState(stateCopy);    
    }
    handleCallbackUrl(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.CallbackUrl = value;
        this.setState(stateCopy);    
    }
    handleConsumerKey(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.ConsumerKey = value;
        this.setState(stateCopy);    
    }
    handleConsumerSecret(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.ConsumerSecret = value;
        this.setState(stateCopy);    
    }
    handleSigningCertificate(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.SigningCertificate = value;
        this.setState(stateCopy);    
    }
    handleSigningCertificatePassword(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.SigningCertificatePassword = value;
        this.setState(stateCopy);    
    }
    handleDayWeekNumber(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.DayWeekNumber = value;
        this.setState(stateCopy);    
    }
    handleHour(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.Hour = value;
        this.setState(stateCopy);    
    }
    handleEmailsAlertTo(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.EmailsAlertTo = value;
        this.setState(stateCopy);    
    }
    handleEmailSubjectError(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.EmailSubjectError = value;
        this.setState(stateCopy);    
    }

    ValidateSaveXero(){

        //var UserName = this.state.EasyApiUser;
        //var Pass = this.state.EasyApiPassword;
        var ApiAccess = this.state.ApiAccess;
        var CallbackUrl = this.state.CallbackUrl;
        var ConsumerKey = this.state.ConsumerKey;
        var ConsumerSecret = this.state.ConsumerSecret;
        var SigningCertificate = this.state.SigningCertificate;
        var SigningCertificatePassword = this.state.SigningCertificatePassword;
        var EmailsAlertTo = this.state.EmailsAlertTo;
        var EmailSubjectError = this.state.EmailSubjectError;

        if(ApiAccess === null || ApiAccess === "" || ApiAccess === undefined)
        {
            toast.error("Api Access field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(CallbackUrl === null || CallbackUrl === "" || CallbackUrl === undefined)
        {
            toast.error("Callback Url field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(ConsumerKey === null || ConsumerKey === "" || ConsumerKey === undefined)
        {
            toast.error("Consumer Key field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(ConsumerSecret === null || ConsumerSecret === "" || ConsumerSecret === undefined)
        {
            toast.error("Consumer Secret field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(SigningCertificate === null || SigningCertificate === "" || SigningCertificate === undefined)
        {
            toast.error("Certificate field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(SigningCertificatePassword === null || SigningCertificatePassword === "" || SigningCertificatePassword === undefined)
        {
            toast.error("Certificate Password field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(EmailsAlertTo === null || EmailsAlertTo === "" || EmailsAlertTo === undefined)
        {
            toast.error("Emails Alert To field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(EmailSubjectError === null || EmailSubjectError === "" || EmailSubjectError === undefined)
        {
            toast.error("Email Subject Error field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        return true;
    }
   
    SaveXero(e){
        e.preventDefault();    
        var email = sessionStorage.getItem('email');
        var that = this;
        var SubGroups = this.state.SubGroups;
        var EasyApiUser = this.state.EasyApiUser;
        var EasyApiPassword = this.state.EasyApiPassword;
        var ApiAccess = this.state.ApiAccess;
        var CallbackUrl = this.state.CallbackUrl;
        var ConsumerKey = this.state.ConsumerKey;
        var ConsumerSecret = this.state.ConsumerSecret;
        var SigningCertificate = this.state.SigningCertificate;
        var SigningCertificatePassword = this.state.SigningCertificatePassword;
        var DayWeekNumber = this.state.DayWeekNumber;
        var Hour = this.state.Hour;
        var EmailsAlertTo = this.state.EmailsAlertTo;
        var EmailSubjectError = this.state.EmailSubjectError;
        var CompanyCode = this.props.CompanyCode;
        var XeroList = this.props.DataXero;
        var Xero = XeroList.find(x=> x.ALIAS === this.state.APIName);  

        var Validate = this.ValidateSaveXero();
        if(Validate === false)
        {
            return false;
        }        
        
        this.setState({
            loadingXero: true
        });
        var result = APIService.SaveXeroSetting(CompanyCode,email, SubGroups, EasyApiUser, EasyApiPassword,ApiAccess, CallbackUrl, ConsumerKey, ConsumerSecret,SigningCertificate,
                                                    SigningCertificatePassword, DayWeekNumber, Hour, EmailsAlertTo, EmailSubjectError);
        result.then(function(data){
            if(data.data === "OK"){
                that.setState({
                    loadingXero: false
                });
                var newList = {
                    ALIAS: Xero.ALIAS,
                    COMPANY_CODE: CompanyCode,
                    ID: Xero.ID,
                    NAME: Xero.NAME,
                    VALUE: {
                        SubGroups: SubGroups,
                        EasyApiUser:EasyApiUser,
                        EasyApiPassword: EasyApiPassword,
                        ApiAddress:ApiAccess,
                        CallbackUrl: CallbackUrl,
                        ConsumerKey: ConsumerKey,
                        ConsumerSecret: ConsumerSecret,
                        SigningCertificate: SigningCertificate,
                        SigningCertificatePassword: SigningCertificatePassword,
                        DayWeekNumber: DayWeekNumber,
                        Hour: Hour,
                        EmailsAlertTo: EmailsAlertTo,
                        EmailSubjectError: EmailSubjectError,
                        Name:Xero.ALIAS
                    }
                };
                that.props.SetObject(newList);
                toast.success("Saved!", { className: {
                    opacity: 0.8
                }});            
            }else if(data.data === "NoExist"){
                that.setState({
                    loadingXero: false
                });  
                toast.error("API Setting dosen't exist!", { className: {
                    opacity: 0.8
                }});
            }else if(data.data === "Empty"){
                that.setState({
                    loadingXero: false
                });                
                toast.error("Not Exist!", { className: {
                    opacity: 0.8
                }});
            }
        }).catch((error) => {

            that.setState({
                loadingXero: false,
            });      
            if(error.response)
            {
                if(error && error.response && error.response.data.Message === "500") {               
                    toast.error("Error Data Base(Error: 500)", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NoDB") {
                   toast.error("Company Code dosen't exist!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NotReseller") {    
                   toast.error("This User does not have permission!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data.Message === "400"){ 
                   toast.error("API Error for Reseller", { className: {
                       opacity: 0.8
                   }});
                }else if(error.response.status === 401){ 
                       sessionStorage.setItem("user", '');
                       sessionStorage.setItem("token", '');
                       sessionStorage.setItem("rol", '');
                       sessionStorage.setItem("email", '');
                       sessionStorage.clear();  
                       this.setState({ isAutenticated: false },
                       ()=>{                               
                           this.forceUpdate();
                       })              
                }   
            }else{
                toast.error("Code Error", { className: {
                    opacity: 0.8
                }});
            }
        });        
    }   
    render(){     
        
        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'}/>)
        }
        
        return (
            <div>
                <div className="card Logs"><ToastContainer hideProgressBar/>
                    <div className="card-body" style={{ height: "600px", 'overflowY': 'scroll'}}>
                        <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Name</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="name" id="name" type="text" value={ this.state.APIName} readOnly/>
                            </div> 
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>SubGroups</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="SubGroups" id="SubGroups" type="text" onChange={this.handleSubGroups} value={ this.state.SubGroups} />
                            </div>                          
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Easy API User</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="clientapiuser" id="clientapiuser" type="text" onChange={this.handleEasyApiUser}  value={ this.state.EasyApiUser}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Easy API Password</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="clientapipass" id="clientapipass" type={this.state.type} onChange={this.handleEasyApiPassword }   value={ this.state.EasyApiPassword}/>
                            </div>    
                            <div className="col-2" style={{ 'paddingTop': '15px' }}>                                
                                <Badge color="default" style={{ 'cursor': 'pointer'}} className="password__show" onClick={this.showHide}>{this.state.type === 'input' ? 'Hide' : 'Show'}</Badge>
                            </div>                      
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Api Access(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="ApiAccess" id="ApiAccess" type="text" onChange={this.handleApiAccess}  value={ this.state.ApiAccess}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Callback Url(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2">
                                <input type="text" style={{ 'marginTop': '10px' }} className="form-control" name="CallbackUrl" id="CallbackUrl"  onChange={this.handleCallbackUrl }   value={ this.state.CallbackUrl}/>
                            </div>                         
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Consumer Key(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="ConsumerKey" id="ConsumerKey" type="text" onChange={this.handleConsumerKey}  value={ this.state.ConsumerKey}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Consumer Secret(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="ConsumerSecret" id="ConsumerSecret" type="text" onChange={this.handleConsumerSecret }   value={ this.state.ConsumerSecret}/>
                            </div>                           
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Certificate(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="CompanyId" id="CompanyId" type="text" onChange={this.handleSigningCertificate } value={ this.state.SigningCertificate}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Certificate Password(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="SigningCertificatePassword" id="SigningCertificatePassword" type="text" onChange={this.handleSigningCertificatePassword }  value={ this.state.SigningCertificatePassword}/>
                            </div>                          
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Day Week Number</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                {/* <input style={{ 'marginTop': '10px'}} className="form-control" name="FtpPath" id="FtpPath" type="text" onChange={this.handleFtpPath } value={ this.state.FtpPath}/> */}
                                <select className="form-control" id="DayWeekNumber" name="DayWeekNumber" value={this.state.DayWeekNumber} onChange={ this.handleDayWeekNumber}>
                                    <option value="-2" >Pay Period First Day</option>
                                    <option value="-1" >Pay Period Last Day</option>
                                    <option value="0"  >Sunday</option>
                                    <option value="1"  >Monday</option>
                                    <option value="2"  >Tuesday</option>
                                    <option value="3"  >Wednesday</option>
                                    <option value="4"  >Thursday</option>
                                    <option value="5"  >Friday</option>
                                    <option value="6"  >Saturday</option>                                    
                                </select>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Process Start Hour</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="Hour" id="Hour" type="text" onChange={this.handleHour }  value={ this.state.Hour}/>
                            </div>                          
                       </div>                      
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Emails Alert To(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="EmailsAlertTo" id="EmailsAlertTo" type="text" onChange={this.handleEmailsAlertTo} value={ this.state.EmailsAlertTo}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Email Subject Error(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="EmailSubjectError" id="EmailSubjectError" type="text" onChange={this.handleEmailSubjectError }  value={ this.state.EmailSubjectError}/>
                            </div>                                       
                            <div className="col-2 offset-1"  size="sm" >
                                <ClipLoader
                                    className={override}
                                    sizeUnit={"px"}
                                    size={30}
                                    color={'#33B5E5'}
                                    loading={this.state.loadingXero}
                                />
                                {
                                    this.state.loadingXero
                                    ?
                                    <Button   color="info" tag="a" onClick={(e)=>this.SaveXero(e)} disabled>Save</Button>
                                    : 
                                    <Button   color="info" tag="a" onClick={(e)=>this.SaveXero(e)}>Save</Button>
                                }
                               
                            </div>                             
                       </div>
                   </div>
                </div>
            </div>            
        );
    }
}

export default Xero;


// WEBPACK FOOTER //
// ./src/APIComponent/Xero.jsx